module.exports = __webpack_public_path__ + "img/49.13c804c2.png";